import React, { useState, useEffect } from "react";
import PeriodLineTab from "Samarth Module/components/periodLineTab/periodLineTab";
import styles from "./insight.module.css";
import BarAndLineComboChart from "Samarth Module/components/barAndLineComboChart/barAndLineComboChart";
import BarAndLineComboChartAgileOr from "Samarth Module/components/barAndLineComboChart/barAndLineComboChartAgileOr";
import DemandTable from "Samarth Module/components/table/demandTable";
import AgileOrTable from "Samarth Module/components/table/mdTable/agileOrTable";

const AlertDemand = ({
    details = {},
    baseUnitOfMeasure = "units",
    currentWeek,
    isAgileSummary,
    summaryCapsuleData
}) => {

    const findSelectedLine = () => {
        if (!details.weeks || !currentWeek) return details.weeks?.[0] || "";

        // Convert week strings to numbers for comparison
        const num = (w) => parseInt(w.replace(/[^0-9]/g, ""));

        const current = num(currentWeek);

        return details.weeks.find((week) => {
            // Handle week range & convert to number
            const numbers = week.split(/-|to/i).map((w) => parseInt(w.replace(/[^0-9]/g, "")));

            // Check if it's a valid week range & not single week
            if (numbers.length === 2 && !isNaN(numbers[0]) && !isNaN(numbers[1])) {
                const [start, end] = numbers;
                if (end < start) {
                    return current >= start || current <= end;
                }
                return current >= start && current <= end;
            }
            // For single week entries
            return parseInt(week.replace(/[^0-9]/g, "")) === current;
        }) || details.weeks[0];

    };

    const [selectedLine, setSelectedLine] = useState(() => {
        return isAgileSummary ? "" : findSelectedLine();
    });

    const [tableValues, setTableValues] = useState(isAgileSummary ? details : details[selectedLine]);

    useEffect(() => {
        if (isAgileSummary) {
            setTableValues(details || {});
        } else {
            const selectedData = details[selectedLine] || {};
            setTableValues(selectedData);
        }
    }, [selectedLine, details, isAgileSummary]);

    const horizontalLineHandler = (tabname) => {
        if (!isAgileSummary) {
            setSelectedLine(tabname);
        }
    };

    return (
        <div className={styles.demandContainer}>
            {!isAgileSummary ? (
                <PeriodLineTab
                    selectedLine={selectedLine}
                    horizontalLineHandler={horizontalLineHandler}
                    values={details.weeks || []}
                >
                    <BarAndLineComboChart details={tableValues} weekLabel={selectedLine} />
                    <DemandTable
                        data={tableValues}
                        weekLabel={selectedLine}
                        unitOfMeasure={baseUnitOfMeasure}
                    />
                </PeriodLineTab>
            ) : (
                <>
                    <BarAndLineComboChartAgileOr details={tableValues} capsuleData={summaryCapsuleData} />
                    <AgileOrTable data={tableValues} />
                </>
            )}
        </div>
    );
};

export default React.memo(AlertDemand);

